import { Icon, X } from '@/components/atoms/Icon';
import { IconButton } from '@/components/atoms/IconButton';
import { Badge } from '@/components/atoms/Badge';
import { cn } from '@/utils/cn';
import type { SidebarProps } from './Sidebar.types';
import styles from './Sidebar.module.scss';

export function Sidebar({
  navItems,
  activePath,
  onNavigate,
  isOpen = false,
  onClose,
  ...props
}: SidebarProps) {
  const sidebarClasses = cn(styles.sidebar, isOpen && styles['sidebar--open']);

  const handleItemClick = (path: string) => {
    onNavigate(path);
    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      {/* Mobile overlay */}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      {isOpen && <div className={styles.sidebar__overlay} onClick={onClose} />}

      {/* Sidebar */}
      <aside className={sidebarClasses} {...props}>
        {/* Mobile: Close button */}
        <div className={styles.sidebar__header}>
          {onClose && (
            <IconButton icon={X} buttonSize="sm" onClick={onClose} aria-label="Close sidebar" />
          )}
        </div>

        {/* Navigation */}
        <nav className={styles.sidebar__nav}>
          {navItems.map((item) => {
            const isActive = activePath === item.path || activePath.startsWith(item.path + '/');

            return (
              <button
                key={item.path}
                type="button"
                className={cn(
                  styles.sidebar__nav__item,
                  isActive && styles['sidebar__nav__item--active']
                )}
                data-no-press-scale=""
                onClick={() => handleItemClick(item.path)}
                aria-current={isActive ? 'page' : undefined}
              >
                <Icon icon={item.icon} size="md" />
                <span className={styles.sidebar__nav__item__label}>{item.label}</span>
                {item.badge && item.badge > 0 && (
                  <Badge variant="error" size="sm" className={styles.sidebar__nav__item__badge}>
                    {item.badge > 99 ? '99+' : item.badge}
                  </Badge>
                )}
              </button>
            );
          })}
        </nav>
      </aside>
    </>
  );
}

export default Sidebar;
